import React from 'react';
import { cn } from '@/utils/cn';
import { fieldClass } from '@/components/UI/fieldStyles';
import { SearchIcon } from '@/components/UI/icons';

export interface SearchInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  /** Accessible name; defaults to the placeholder. */
  label?: string;
  wrapperClassName?: string;
}

/** Pill search box with a leading magnifier. Use for list-page toolbars. */
export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ label, placeholder = 'Search…', className, wrapperClassName, ...props }, ref) => (
    <div className={cn('relative w-full max-w-sm', wrapperClassName)}>
      <SearchIcon size={16} className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-ui-text3" />
      <input
        ref={ref}
        type="search"
        aria-label={label ?? placeholder}
        placeholder={placeholder}
        className={cn(fieldClass({ size: 'sm' }), 'pl-10', className)}
        {...props}
      />
    </div>
  ),
);
SearchInput.displayName = 'SearchInput';

export default SearchInput;
